import { useEffect } from 'react';

interface IPaymentSimplex {
  paymentId: string
  partner: string
}

const PaymentSimplex = ({paymentId, partner}: IPaymentSimplex)  => {
  useEffect(() => {
    const form = document.getElementById('payment_form') as HTMLFormElement;
    if (form) {
      form.submit();
    }
  }, []);

  return (
    <form id="payment_form" action={import.meta.env.VITE_SIMPLEX || 'https://sandbox.test-simplexcc.com/payments/new'} method="post" target="_self">
      <input type="hidden" name="version" value="1" />
      <input type="hidden" name="partner" value={partner} />
      <input type="hidden" name="payment_flow_type" value="wallet" />
      <input type="hidden" name="return_url_success" value={window.location.origin} />
      <input type="hidden" name="return_url_fail" value={window.location.origin} />
      <input type="hidden" name="payment_id" value={paymentId} />
    </form>
  );
};

export default PaymentSimplex;
